var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04656 5.70726L3.41392 6.36113L3.04656 5.70726C1.04764 6.83032 1.04762 9.71656 3.04656 10.8396L9.21013 14.3025C11.1007 15.3647 13.4042 15.3647 15.2947 14.3025L21.4583 10.8396C23.4572 9.71657 23.4572 6.83033 21.4583 5.70726L15.2947 2.24438C13.4042 1.18221 11.1007 1.18221 9.21013 2.24437L9.56881 2.88279L9.21013 2.24437L3.04656 5.70726Z",
    stroke: "#CACBCA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65883 19.7044C2.7274 19.1811 2.54921 17.9836 3.13336 17.2078L8.5824 20.2692C10.8628 21.5504 13.6421 21.5504 15.9224 20.2692L21.3715 17.2078C21.9556 17.9836 21.7774 19.1811 20.846 19.7044L14.6824 23.1673C13.1721 24.0158 11.3327 24.0158 9.8224 23.1673L3.65883 19.7044Z",
    stroke: "#CACBCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23873 10.9833L2.72225 10.6932L2.32035 11.1284C1.09224 12.4584 1.32464 14.7217 3.04656 15.6891L9.21013 19.152C11.1007 20.2141 13.4042 20.2141 15.2947 19.152L21.4583 15.6891C23.1802 14.7217 23.4126 12.4584 22.1845 11.1284L21.7826 10.6932L21.2661 10.9833L15.3101 14.3296C13.41 15.3971 11.0948 15.3971 9.19467 14.3296L3.23873 10.9833Z",
    stroke: "#CACBCA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.f30be6bd5824ffa6124202816774de85.svg";
export { ForwardRef as ReactComponent };